import React from 'react';
import { useSelector } from 'react-redux';
import ModernDashboard from './ModernDashboard';
import UserDashboard from './UserDashboard';

/**
 * Dashboard Router - Routes to appropriate dashboard based on user role and org membership
 * - Platform admin/instructor: ModernDashboard
 * - Platform user: UserDashboard
 * - Org admin: ModernDashboard (scoped to org clusters)
 * - Org instructor/user: UserDashboard (scoped to org clusters)
 */
const DashboardRouter = (props) => {
	const user = useSelector(({ auth }) => auth.user);

	// Determine if user should see the admin dashboard
	const isAdmin = () => {
		if (!user || !user.role) return false;
		const roles = Array.isArray(user.role) ? user.role : [user.role];
		return roles.some(r => r === 'admin' || r === 'super-admin');
	};

	const isInstructor = () => {
		if (!user || !user.role) return false;
		const roles = Array.isArray(user.role) ? user.role : [user.role];
		return roles.includes('instructor');
	};

	// Org users: admin gets ModernDashboard, everyone else gets UserDashboard
	if (user && user.organizationId) {
		if (isAdmin()) {
			return <ModernDashboard {...props} />;
		}
		return <UserDashboard {...props} />;
	}

	// Platform users: admin/instructor gets ModernDashboard, regular users get UserDashboard
	if (isAdmin() || isInstructor()) {
		return <ModernDashboard {...props} />;
	}

	return <UserDashboard {...props} />;
};

export default DashboardRouter;
